import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { isPostHogEnabled, posthog } from '@/setupPostHog'

export function usePostHogPageView() {
  const location = useLocation()

  useEffect(() => {
    if (!isPostHogEnabled) return

    posthog.capture('$pageview', {
      $current_url: window.location.href,
    })
  }, [location.pathname, location.search])
}
